import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import HeadSub from '../../../components/comm/HeadSub';
import SwitchBox from '../../../components/box/SwitchBox';
import style from './Alarm.module.css';
import noDataImg from '../../../images/common/i_3d_no_data_doc.svg';
import Skeleton from '@mui/material/Skeleton';
import axiosApi from '../../../api/daonAxios';
import URL from '../../../constants/url';

const SkeletonLoader = () => (
    <div className={style.listWrap}>
        {[...Array(4)].map((_, i) => (
            <div key={i} className={style.notiCard} style={{ background: '#fff' }}>
                <Skeleton variant="text" width="85%" height={22} style={{ borderRadius: '4px', marginBottom: '4px' }} />
                <Skeleton variant="text" width="60%" height={20} style={{ borderRadius: '4px', marginBottom: '8px' }} />
                <Skeleton variant="text" width="40%" height={16} style={{ borderRadius: '4px' }} />
            </div>
        ))}
    </div>
);

const formatAlarmDate = (date) => {
    if (!date || date.length < 12) return '';

    return `${date.substring(0, 4)}.${date.substring(4, 6)}.${date.substring(6, 8)} ${date.substring(8, 10)}:${date.substring(10, 12)}`;
};

const Alarm = () => {
    const navigate = useNavigate();
    const [unreadOnly, setUnreadOnly] = useState(false);
    const [notifications, setNotifications] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const fetchAlarmList = async () => {

        try {
            setIsLoading(true);

            const jToken = localStorage.getItem('jToken');

            const res = await axiosApi.get('/alarm/list', {
                headers: {
                    Authorization: `Bearer ${jToken}`,
                },
            });
            setNotifications(res.data.result || []);

        } catch (error) {
            console.error('알림 조회 실패', error);
            setNotifications([]);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchAlarmList();
    }, []);

    const filtered = unreadOnly ? notifications.filter(item => item.cnfrmAt === '0') : notifications;

    const handleItemClick = async (item) => {

        try {

            if (item.cnfrmAt === '0') {

                const jToken = localStorage.getItem('jToken');

                await axiosApi.put(
                    `/alarm/${item.id}/confirm`,
                    {},
                    {
                        headers: {
                            Authorization: `Bearer ${jToken}`,
                        },
                    }
                );

                setNotifications(prev =>
                    prev.map(n =>
                        n.id === item.id
                            ? { ...n, cnfrmAt: '1' }
                            : n
                    )
                );
            }

            // 알림 종류별 이동
            // item.alrmTyCd
            // item.cnncPrmtrVal
            if(item.usrDfnFld3) {
                navigate(item.usrDfnFld3);
            }

        } catch (error) {
            console.error('알림 확인 처리 실패', error);
        }
    };

    return (
        <>
            <HeadSub title="알림" />

            <div id="sub-content">
                <div className="inner-wrap">

                    {/* 미확인 알림 토글 */}
                    <div className={style.filterRow}>
                        <div className={style.switchLabel}>
                            <SwitchBox toggles={unreadOnly} status={setUnreadOnly} size="small" />
                            <span>미확인 알림</span>
                        </div>
                    </div>

                    {/* 알림 리스트 */}
                    {isLoading ? (
                        <SkeletonLoader />
                    ) : filtered.length > 0 ? (
                        <div className={style.listWrap}>
                            {/* {filtered.map(item => (
                                <div key={item.id} className={style.notiCard}
                                    data-read={item.read ? 'on' : 'off'}
                                    onClick={() => handleItemClick(item)}>
                                    <p className={style.notiTitle}>{item.title}</p>
                                    <span className={style.notiDate}>
                                        {!item.read && <em className={style.unreadDot} />}
                                        {item.date}
                                    </span>
                                </div>
                            ))} */}

                            {filtered.map(item => (
                                <div
                                    key={item.id}
                                    className={style.notiCard}
                                    data-read={item.cnfrmAt === '1' ? 'on' : 'off'}
                                    onClick={() => handleItemClick(item)}
                                >
                                    <p className={style.notiTitle}>
                                        {item.alrmCn}
                                    </p>

                                    <span className={style.notiDate}>
                                        {item.cnfrmAt === '0' && (
                                            <em className={style.unreadDot} />
                                        )}
                                        {formatAlarmDate(item.sndngRsvtDt)}
                                    </span>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div className={style.noData}>
                            <div className={style.noDataImg}>
                                <object data={noDataImg} aria-hidden="true" />
                            </div>
                            <p>알림이 없습니다.</p>
                        </div>
                    )}

                    {/* 하단 안내 */}
                    {!isLoading && <p className={style.bottomNotice}>최대 30일 전 알림까지만 확인할 수 있어요</p>}
                </div>
            </div>
        </>
    );
};

export default Alarm;